import { isPdf, isWord, isPowerpoint, isVideo, isImage, isAudio, isGifImage, isZip } from '@/helpers/functions'
import * as axios from 'axios';
import { APP_CONFIG } from '@/utils/constants'
import * as types from './constants'
import { mapActions } from 'vuex'
import JWT from "@/utils/jwt"

export default {

    methods: {
        ...mapActions('common', ['setLoading']),

        checkPdf(link) {
            return isPdf(link)
        },
        checkWord(link) {
            return isWord(link)
        },
        checkVideo(link) {
            // alert(2)
            return isVideo(link)
        },
        checkPowerpoint(link) {
            return isPowerpoint(link)
        },

        checkImage(link) {
            return isImage(link)
        },

        checkGifImage(link) {
            return isGifImage(link)
        },

        checkYoutube(link) {
            return link.includes('youtube');
        },

        checkAudio(link) {
            return isAudio(link);
        },

        isFullLink(link) {
            return link.includes('http');
        },

        downloadDocs(link, name, fullLink = false) {
            let fullPath = fullLink ? link : `${APP_CONFIG.bookCdnUrl}${link}`
            let self = this
            self.setLoading(true)

            return axios({
                    url: fullPath,
                    method: 'GET',
                    responseType: 'blob'
                }).then((response) => {
                    let fileType = self.checkPdf(link) ? 'application/pdf' : ''
                    let fileURL = window.URL.createObjectURL(new Blob([response.data], { type: fileType }))
                    let fileLink = document.createElement('a')
                    // let lengthLink = link.length
                    // let exFile = link.slice(-4, lengthLink)
                    let exFile = link.slice(-4)

                    fileLink.href = fileURL
                    fileLink.setAttribute('download', isZip(link) ? `${name}_HTS.zip` : `${name}_HTS${exFile.toLowerCase() === 'pptx' ? '.pptx' : exFile}`)
                    fileLink.setAttribute('target', '_blank')
                    document.body.appendChild(fileLink)

                    fileLink.click()
                    return response
                })
                .catch(err => this.$toast.error('Đã xảy ra lỗi'))
                .finally(res => {
                    self.setLoading(false)
                    return res
                })
        },

        checkTypeDocs(link) {
            let value = types.NAME_DOC_WORD
            if (this.checkVideo(link)) {
                value = types.NAME_DOC_VIDEO;
            } else if (this.checkPdf(link)) {
                value = types.NAME_DOC_PDF;
            } else if (this.checkPowerpoint(link)) {
                value = types.NAME_DOC_PPTX;
            } else if (this.checkImage(link)) {
                value = types.NAME_DOC_IMG;
            } else if (this.checkYoutube(link)) {
                value = types.NAME_DOC_YOUTUBE;
            } else if (this.checkAudio(link)) {
                value = types.NAME_DOC_AUDIO;
            }
            return value;
        },

        getNameIcomImg(link, isGroup = false) {
            if (isGroup) {
                return 'nhom-hoc-lieu'
            } else if (isGifImage(link)) {
                return 'gif'
            } else if (isImage(link)) {
                return 'image'
            } else if (isAudio(link)) {
                return 'audio'
            } else {
                return 'play'
            }
        }
    }
}